<script lang="ts" setup>
import thankYouImg from './assets/thank-you.png'

// Illustrative thank-you moment shown as the demo's final beat (beat 10): a
// recipient happily off to enjoy their gift. Presentational only — the sr-only
// text stands in for the illustration for a11y and test assertions.
</script>

<template>
  <div class="thank-you-bubble">
    <span class="sr-only">Them: Thank you so much for such a thoughtful gift!</span>
    <img :src="thankYouImg" alt="" class="thank-you-image">
  </div>
</template>

<style scoped lang="scss">
.thank-you-bubble {
  // Spring to full size once visible. The delay holds the small `from` state
  // through the parent's 0.3s fade-in, so the pop lands on the now-opaque image
  // instead of being masked by (and overlapping) the fade. Opacity is left to
  // the parent transition so there's no blank gap during the delay.
  animation: bubble-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s both;
  width: 100%;
}

.thank-you-image {
  display: block;

  // The tile has rounded corners with transparent edges, so drop-shadow (which
  // follows the alpha) hugs its shape — box-shadow would leak past the corners.
  filter: drop-shadow(0 14px 24px rgb(17 30 54 / 22%));
  height: auto;
  transform: translateZ(0);
  width: 100px;
}

@keyframes bubble-in {
  from {
    transform: translateY(10px) scale(0.85);
  }

  to {
    transform: translateY(0) scale(1);
  }
}
</style>
